// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"806":"4163ae0c","2366":"1d2671aa"}[chunkId] || chunkId) + "." + {"806":"14fd0cbc9b731324","963":"f00070a4cae5e2d5","2366":"0b38834ffa284870","2635":"d3781534f226501b","7655":"9f14c53765cbf3d7","8270":"82f2d8fc97293e39","9438":"2199df1b3159b2d8"}[chunkId] + ".js";
};